import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Para qué edad es este material?',
    a: 'Está diseñado para adolescentes de 12 a 18 años. El lenguaje, los ejercicios y las actividades están adaptados a su realidad: redes sociales, presión académica, relaciones y búsqueda de identidad.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo con el acceso a todos los PDFs. En menos de 5 minutos podés estar usando el primer tomo.'
  }, {
    q: '¿Lo puede usar el adolescente solo o necesita un adulto?',
    a: 'Muchos ejercicios pueden hacerse solos, pero los mejores resultados se dan cuando un adulto acompaña el proceso. Por eso incluimos guías específicas para padres y docentes.'
  }, {
    q: '¿Qué lo diferencia de lo que hay gratis en internet?',
    a: 'No es teoría suelta ni consejos genéricos. Es un sistema estructurado tomo a tomo con ejercicios prácticos, scripts listos para usar, tarjetas imprimibles y un plan de 30 días. Todo diseñado para funcionar en la vida real.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin drama. Punto.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-57">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden transition-colors hover:border-cosmic-600/50" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-60">
                <span className="font-semibold text-lg text-white pr-8" data-id="element-61">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-cosmic-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-63">
                <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-navy-700/50 pt-4 mt-2" data-id="element-64">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}